"use client";

import React, { Suspense } from "react";

import PageNotFound from "@/components/pages/page-not-found/page-not-found";

import "@/app/globals.css";

// No `metadata` export here: error boundaries and this not-found UI are Client
// Components, where Next.js does not support metadata exports. It was never
// applied, and Next.js 16's metadata collector crashes on it while prerendering
// /_not-found. The identical title/icon come from `app/layout.tsx`.
function NotFound() {
  return (
    <Suspense fallback={<div />}>
      <div data-testid="notfound-page-testid">
        <PageNotFound />
      </div>
    </Suspense>
  );
}

export default NotFound;
